<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>business</mat-icon>
    </div>
    <div class="icf-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" [message]="isEdit ? 'Cargando inversión…' : 'Preparando formulario…'"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando inversión…' : 'Creando inversión…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="icf-alert icf-alert--error">
        <mat-icon>error</mat-icon>
        <span>{{ isEdit ? 'No se pudo cargar la inversión.' : 'No se pudieron cargar los datos del formulario.' }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body" [formGroup]="form">

      <div class="icf-section">
        <span class="cf-dlg-section__label">Datos de la inversión</span>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.account">
          <app-autocomplete [control]="accountControl" [config]="{ label: 'Tipo de inversión (cuenta contable)', placeholder: 'Seleccionar cuenta…', options: accounts, autoSelectSingle: true, strict: true }">
          </app-autocomplete>
          <div class="cf-field__error" *ngIf="submitted && errors.account"><mat-icon>error</mat-icon> {{ errors.account }}</div>
          <div class="icf-hint" *ngIf="!accounts.length">No tienes cuentas contables de inversiones en empresas (240, 241, 500 o 510).</div>
        </div>

        <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.investmentDescription">
          <app-field [control]="investmentDescriptionControl" [config]="{ label: 'Descripción', required: true, maxLength: descriptionMaxLength, hint: descriptionLength + ' / ' + descriptionMaxLength }"></app-field>
          <div class="cf-field__error" *ngIf="submitted && errors.investmentDescription"><mat-icon>error</mat-icon> {{ errors.investmentDescription }}</div>
        </div>

        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.investmentValue">
            <app-field [control]="investmentValueControl" [config]="{ label: 'Valor de la inversión', type: 'number', required: true, suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.investmentValue"><mat-icon>error</mat-icon> {{ errors.investmentValue }}</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.investmentDate">
            <app-date [control]="investmentDateControl" [config]="{ label: 'Fecha de la inversión', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && errors.investmentDate"><mat-icon>error</mat-icon> {{ errors.investmentDate }}</div>
          </div>
        </div>
      </div>

      <div class="icf-section">
        <span class="cf-dlg-section__label">Participaciones y rendimientos</span>

        <div class="cf-dlg-row">
          <div [class.cf-field--invalid]="submitted && errors.numberOfUnitsOrSharesInvested">
            <app-field [control]="numberOfUnitsControl" [config]="{ label: 'Nº de participaciones o acciones', type: 'number', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.numberOfUnitsOrSharesInvested"><mat-icon>error</mat-icon> {{ errors.numberOfUnitsOrSharesInvested }}</div>
          </div>

          <div [class.cf-field--invalid]="submitted && errors.percentageOfProfitabilityOrInterest">
            <app-field [control]="percentageControl" [config]="{ label: 'Rentabilidad / interés', type: 'number', suffix: '%', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.percentageOfProfitabilityOrInterest"><mat-icon>error</mat-icon> {{ errors.percentageOfProfitabilityOrInterest }}</div>
          </div>

          <div [class.cf-field--invalid]="submitted && errors.termInMonths">
            <app-field [control]="termInMonthsControl" [config]="{ label: 'Plazo (meses)', type: 'number', min: 0, max: 255, step: 1, inputmode: 'numeric' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.termInMonths"><mat-icon>error</mat-icon> {{ errors.termInMonths }}</div>
          </div>
        </div>

        <div class="cf-dlg-row">
          <div [class.cf-field--invalid]="submitted && errors.netBookValue">
            <app-field [control]="netBookValueControl" [config]="{ label: 'Valor neto del último balance', type: 'number', suffix: '€', step: 0.01, inputmode: 'decimal' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && errors.netBookValue"><mat-icon>error</mat-icon> {{ errors.netBookValue }}</div>
          </div>

          <div>
            <app-date [control]="lastBalanceSheetDateControl" [config]="{ label: 'Fecha del último balance' }"></app-date>
          </div>
        </div>

        <app-checkbox class="icf-toggle" [formControl]="generatesReturnsControl" [config]="{ label: 'Genera rendimientos' }"></app-checkbox>
      </div>

      <div class="icf-section">
        <span class="cf-dlg-section__label">
          Documento adjunto
          <span class="icf-file-actions">
            <input #fileInput class="icf-file-input" type="file" accept=".pdf,.png,.jpg,.jpeg" (change)="onFileSelected($event)">
            <button mat-stroked-button type="button" class="cf-btn" (click)="fileInput.click()" [disabled]="loadingFile">
              <mat-icon>file_upload</mat-icon> Subir archivo
            </button>
            <button mat-stroked-button type="button" class="cf-btn" (click)="pickFromFiles()" [disabled]="loadingFile">
              <mat-icon>folder</mat-icon> Desde Ficheros
            </button>
            <button *ngIf="hasFile" mat-stroked-button type="button" class="cf-btn icf-btn--danger" (click)="removeFile()" [disabled]="loadingFile">
              <mat-icon>delete</mat-icon> Quitar
            </button>
          </span>
        </span>

        <app-loading-state *ngIf="loadingFile" [compact]="true" message="Cargando documento…"></app-loading-state>

        <ng-container *ngIf="!loadingFile">
          <div class="icf-file-preview" *ngIf="hasFile && (imageUrl || pdfUrl); else noFile">
            <img *ngIf="isImage && imageUrl" [src]="imageUrl" alt="Documento de la inversión">
            <iframe *ngIf="isPdf && pdfUrl" [src]="pdfUrl" title="Documento de la inversión"></iframe>
          </div>
          <ng-template #noFile>
            <div class="icf-file-empty">
              <mat-icon>attach_file</mat-icon>
              <span *ngIf="!hasFile">Adjunta la escritura, el contrato o el justificante de la inversión (PDF, PNG o JPG).</span>
              <span *ngIf="hasFile">Hay un documento adjunto, pero no se pudo mostrar la vista previa.</span>
            </div>
          </ng-template>
        </ng-container>
      </div>

      <div class="icf-alert icf-alert--error" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="loadingFile">
        <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear inversión' }}
      </button>
    </div>
  </ng-container>
</div>
